<template>
  <div>
    <h2 class="transfer-title">应收账款转让通知书列表</h2>
    <div class="transfer-list">
      <el-form ref="form"
               class="transfer-list__search"
               :inline="true"
               :model="search"
               label-width="90px">
        <el-form-item label="通知书编号">
          <el-input v-model="search.adviceCode"></el-input>
        </el-form-item>
        <el-form-item label="合同编号">
          <el-input v-model="search.contractNo"></el-input>
        </el-form-item>
        <el-form-item label="项目编号">
          <el-input v-model="search.applyCode"></el-input>
        </el-form-item>
        <el-form-item label="项目名称">
          <el-input v-model="search.applyTitle"></el-input>
        </el-form-item>
        <el-form-item label="产品名称">
          <el-input v-model="search.productName"></el-input>
        </el-form-item>
        <el-form-item label="核心企业">
          <el-input v-model="search.buyerName"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     class="search-btn"
                     @click="searchList">查询</el-button>
        </el-form-item>
      </el-form>

      <!--列表数据-->
      <el-table :data="adviceList"
                style="width: 100%"
                align="center">
        <el-table-column label="序号"
                         width="65"
                         align="center">
          <template slot-scope="scope">{{scope.$index+1}}</template>
        </el-table-column>
        <el-table-column prop="adviceCode"
                         show-overflow-tooltip
                         label="通知书编号"
                         width="110"
                         align="center"></el-table-column>
        <el-table-column prop="applyCode"
                         show-overflow-tooltip
                         label="项目编号"
                         width="100"
                         align="center"></el-table-column>
        <el-table-column prop="applyTitle"
                         show-overflow-tooltip
                         label="项目名称"
                         width="100"
                         align="center"></el-table-column>
        <el-table-column prop="productName"
                         label="产品名称"
                         width="100"
                         align="center"></el-table-column>
        <!-- <el-table-column prop="contractNo"
                         show-overflow-tooltip
                         label="合同编号"
                         width="100"
                         align="center"></el-table-column> -->
        <el-table-column prop="buyerName"
                         show-overflow-tooltip
                         label="买方"
                         width="100"
                         align="center"></el-table-column>
        <!-- <el-table-column prop="receivablesAmount"
                         show-overflow-tooltip
                         label="应收账款(元)"
                         width="120"
                         align="center"></el-table-column>
        <el-table-column prop="receivableEndTime"
                         show-overflow-tooltip
                         label="到期日"
                         width="90"
                         align="center"></el-table-column> -->
        <el-table-column prop="adviceState"
                         show-overflow-tooltip
                         label="确认状态"
                         width="100"
                         align="center"></el-table-column>
        <el-table-column prop="createtime"
                         show-overflow-tooltip
                         label="日期"
                         width="100"
                         align="center"></el-table-column>

        <el-table-column label="操作"
                         align="center">
          <template slot-scope="scope">
            <el-button size="mini"
                       type="primary"
                       @click="goToDetail(scope.row.adviceId)"
                       class="btn operation">查看</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination v-if="adviceList.length > 0"
                     class="transfer-list__pagination"
                     :page-size="pageSize"
                     :total="totalCount"
                     :current-page="currentPage"
                     @current-change="changePage"
                     layout="prev, pager, next"></el-pagination>
    </div>
  </div>
</template>

<script>
import api from '../../api/transferAdvice.js';
export default {
  name: 'TransferAdviceList',
  data () {
    return {
      search: {
        adviceCode: '',
        contractNo: '',
        applyCode: '',
        applyTitle: '',
        productName: '',
        buyerName: ''
      },
      adviceList: [],
      currentPage: 1,
      pageSize: 10,
      totalCount: 0
    };
  },
  methods: {
    getData (search, pageNum = 1, pageSize = 10) {
      const that = this;
      api.getTransferAdviceList(search, pageNum, pageSize).then((resp) => {
        if (resp.data.rspcode == 1) {
          const respData = resp.data.data;
          that.currentPage = respData.currentPage;
          that.totalCount = respData.totalCount;
          that.adviceList = respData.transferAdviceList;
        }
      });
    },
    changePage (pageNum) {
      this.currentPage = pageNum;
      this.getData(this.search, this.currentPage);
    },
    searchList () {
      this.getData(this.search);
    },
    goToDetail (id) {
      this.$router.push(`/personalCenter/transferAdvice/detail/${id}`);
    }
  },
  mounted () {
    this.getData();
  }
};
</script>

<style>
.transfer-title {
  font-size: 22px;
  font-weight: bolder;
  height: 60px;
  line-height: 60px;
  margin-left: 20px;
}

.transfer-list {
  box-sizing: border-box;
  background-color: #fff;
  width: 970px;
  margin-left: 20px;
  padding: 30px 22px 50px 18px;
}
.transfer-list__pagination {
  text-align: center;
  margin-top: 20px;
}
.transfer-list__search {
  width: 910px;
}

.transfer-list__search input {
  width: 150px;
}
.transfer-list__search .search-btn {
  margin-left: 30px;
  width: 80px;
}
</style>




// WEBPACK FOOTER //
// TransferAdviceList.vue?02495668